import { Instance } from "./instance-types";

const SENTRY_DSN = {
    [Instance.App]: "https://714bc62603359a8e3ec14212ac77db77@o4507453584637952.ingest.de.sentry.io/4507453594533968",
    [Instance.La28]: "https://a1011c7b91d983781be79fab0110a689@o4512123644936192.ingest.us.sentry.io/4512123652538368",
};

const REPLAY_SESSION_SAMPLE_RATE = {
    [Instance.App]: 0.15,
    [Instance.La28]: 1.0,
};

export function getInstance(hostname: string) {
    switch (hostname) {
        case "app.trms.la28.org":
        case "la28-staging.iventis.com":
            return Instance.La28;
        default:
            return Instance.App;
    }
}

export function getSentryDsn(instance: Instance) {
    return SENTRY_DSN[instance];
}

export function getReplaySessionSampleRate(instance: Instance) {
    return REPLAY_SESSION_SAMPLE_RATE[instance];
}
